import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const NewFourOhOneKLoanForm = () => {
    const [lenderChoices, setLenderChoices] = useState([]);
    const [selectedLender, setSelectedLender] = useState('');
    const [planName, setPlanName] = useState('');
    const [loanAmount, setLoanAmount] = useState(null);
    const [annualInterestRate, setAnnualInterestRate] = useState(null);
    const [loanTermYears, setLoanTermYears] = useState(null);
    const [noPaymentsPerYear, setNoPaymentsPerYear] = useState(26);
    const [originationDate, setOriginationDate] = useState(null);
    const [firstPaymentDate, setFirstPaymentDate] = useState(null);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLenderChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/lender-choices/');
                setLenderChoices(response.data);
            } catch (err) {
                console.error('Error fetching lender choices:', err);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchLenderChoices();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        try {
            const response = await axios.post('/api/balance_sheet/financing/401k_loans/', {
                plan_name: planName,
                lender: selectedLender,
                amount: loanAmount,
                initial_interest_rate: annualInterestRate,
                term_in_years: loanTermYears,
                n_payments_per_year: noPaymentsPerYear,
                origination_date: originationDate,
                first_payment_date: firstPaymentDate,
                debt_type: '401k_loan',
                rate_type: 'Fixed',
                amortizing: true,
                total_closing_costs: 0,
            });
            navigate(`/balance_sheet/financing/401k_loans/${response.data.id}/`);
        } catch (err) {
            console.error('Error creating 401k loan:', err);
            setError('There was an error creating the 401k loan. Please check your input.');
        }
    };

    return (
        <div className="container mt-4" style={{ marginBottom: '20px' }}>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Plan Name:
                    </label>
                    <input
                        type="text"
                        value={planName}
                        onChange={(e) => setPlanName(e.target.value)}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        placeholder="e.g. Fidelity 401k"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="lender401k" className="text-right d-inline-block"
                           style={{ width: '200px', textAlign: 'right' }}>Lender / Plan Administrator:</label>
                    <select
                        id="lender401k"
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        value={selectedLender}
                        onChange={(e) => setSelectedLender(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a lender</option>
                        {lenderChoices.map(([id, name]) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Loan Amount:
                    </label>
                    <input
                        type="number"
                        value={loanAmount || ''}
                        onChange={(e) => setLoanAmount(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Annual Interest Rate (%):
                    </label>
                    <input
                        type="number"
                        step="0.01"
                        value={annualInterestRate || ''}
                        onChange={(e) => setAnnualInterestRate(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Term (Years):
                    </label>
                    <input
                        type="number"
                        step="0.1"
                        value={loanTermYears || ''}
                        onChange={(e) => setLoanTermYears(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Payments Per Year:
                    </label>
                    <input
                        type="number"
                        value={noPaymentsPerYear}
                        onChange={(e) => setNoPaymentsPerYear(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                    <small className="text-muted" style={{ marginLeft: '215px', display: 'block' }}>26 = bi-weekly (default for 401k loans)</small>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Origination Date:
                    </label>
                    <input
                        type="date"
                        value={originationDate || ''}
                        onChange={(e) => setOriginationDate(e.target.value || null)}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        First Payment Date:
                    </label>
                    <input
                        type="date"
                        value={firstPaymentDate || ''}
                        onChange={(e) => setFirstPaymentDate(e.target.value || null)}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                        required
                    />
                </div>

                <div className="form-group" style={{ marginTop: '20px' }}>
                    <div style={{ marginLeft: '215px' }}>
                        <button type="submit" className="btn btn-primary">Create 401k Loan</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default NewFourOhOneKLoanForm;
